'use es6';
/*
 * Similar to Flashes in Rails
 *
 * http://api.rubyonrails.org/classes/ActionDispatch/Flash.html
 */

import SeamlessImmutable from 'seamless-immutable';
import { FLASH, FLASH_REMOVE } from 'DesignData/actions/ActionTypes';
export default function (state = SeamlessImmutable({}), action) {
  switch (action.type) {
    case FLASH:
      {
        return state.set(action.flashKey, action.message);
      }

    case FLASH_REMOVE:
      {
        return state.without(action.flashKey);
      }

    default:
      return state;
  }
}